import { Stack, TextField, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import { Control, Controller, FieldPath, FieldValues } from "react-hook-form-mui";

import FeedbackIcon from "~/modules/project/components/Feedback/FeedbackIcon";

type Props<T extends FieldValues> = {
    labelComment: string;
    labelTitle: string;
    control: Control<T>;
    feedbackRating?: boolean | null;
};

export default function Feedback<T extends FieldValues>({ labelComment, labelTitle, control, feedbackRating }: Props<T>) {
    return (
        <Stack spacing={2}>
            <Divider>
                <Typography variant="body1">Feedback</Typography>
            </Divider>

            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="h6" display="inline">
                    {labelTitle}
                </Typography>
                <Controller
                    control={control}
                    name={"feedbackRating" as FieldPath<T>}
                    render={({ field }) => <FeedbackIcon feedbackRating={field.value} onChange={field.onChange} />}
                />
            </Stack>

            <Controller
                control={control}
                name={"feedbackComment" as FieldPath<T>}
                rules={{ required: feedbackRating != null }}
                render={({ field }) => (
                    <TextField
                        {...field}
                        value={field.value || ""}
                        label={labelComment}
                        multiline
                        required={feedbackRating != null}
                        maxRows={5}
                        minRows={5}
                        error={(feedbackRating != null && !field.value) || false}
                    />
                )}
            />
        </Stack>
    );
}
